<template>
  <div class="width-100p">
    <v-btn
      depressed
      large
      block
      color="white"
      class="ma-0"
      @click="dialog = true"
    >
      Referral link
    </v-btn>

    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
              <h2 v-if="forAnotherUser" class="text-h5">
                {{ testator.fullName }} unique referral link
              </h2>
              <h2 v-else class="text-h5">Your unique referral link</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog()"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="crud-card-text">
          <div v-if="loading" class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <p v-else>
            <span v-if="forAnotherUser">
              This is the unique referral link for {{ testator.fullName }},
              anyone who signs up using this link will be added as their
              testator.<br /><br />
            </span>
            <span v-else>
              This is your unique referral link, anyone who signs up using this
              link will be added as your testator.<br /><br />
            </span>
            <a :href="referralLink">{{ referralLink }}</a>
          </p>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                large
                color="primary"
                @click="closeDialog()"
              >
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import { GENERATE_REFERRAL_LINK_MUTATION } from '../../constants/graphql/users';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';

  export default {
    name: 'ReferralLink',
    components: {
      ErrorSnackbar,
    },
    props: {
      testator: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        dialog: false,
        showError: false,
        referralLink: null,
        loading: true,
      };
    },
    computed: {
      forAnotherUser() {
        return !!this.testator.id;
      },
    },
    watch: {
      dialog(newValue) {
        if (newValue == true) {
          this.referralLink
            ? (this.loading = false)
            : this.findOrCreateReferralLink();
        }
      },
    },
    methods: {
      findOrCreateReferralLink() {
        this.loading = true;
        const userId = this.forAnotherUser ? this.testator.userId : this.userId;

        this.$apollo
          .mutate({
            mutation: GENERATE_REFERRAL_LINK_MUTATION,
            variables: {
              userId,
            },
          })
          .then(response => {
            this.loading = false;
            this.referralLink = response.data.generateReferralLink;
          })
          .catch(error => {
            this.closeDialog();
            this.showError = true;
            throw error;
          });
      },
      closeDialog() {
        this.dialog = false;
      },
    },
  };
</script>
